import React from 'react';
import { Poppins } from 'src/common/Poppins';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 0;
  width: 100%;
`;

const Label = styled(Poppins)`
  flex: 1;
`;

const Arrow = styled.button<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  padding: 0 2px;
  color: ${({ theme }) => theme.colors.cflowerBlue};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  transition: color 0.15s ease;

  &:not(:disabled):hover {
    color: ${({ theme }) => theme.colors.prussianBlue};
  }
`;

const Count = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  /* tabular-nums so digit width doesn't shift layout when the count changes. */
  font-variant-numeric: tabular-nums;
`;

const Chevron: React.FC<{ dir: 'left' | 'right' }> = ({ dir }) => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d={dir === 'left' ? 'M7 1L1 7L7 13' : 'M1 1L7 7L1 13'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface ResponsesPagerProps {
  /** 1-based current page; 0 when there are no suggestions. */
  current: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

export const ResponsesPager: React.FC<ResponsesPagerProps> = ({ current, total, onPrev, onNext }) => (
  <Row>
    <Label px={16} color="cflowerBlue">
      Responses
    </Label>
    <Arrow type="button" disabled={current <= 1} onClick={onPrev} aria-label="Previous response">
      <Chevron dir="left" />
    </Arrow>
    <Count>
      <Poppins px={16} color="cflowerBlue">
        {current}
      </Poppins>
      <Poppins px={12} color="cflowerBlue">
        /
      </Poppins>
      <Poppins px={16} color="cflowerBlue">
        {total}
      </Poppins>
    </Count>
    <Arrow type="button" disabled={current >= total} onClick={onNext} aria-label="Next response">
      <Chevron dir="right" />
    </Arrow>
  </Row>
);
